module.exports = __webpack_public_path__ + "img/15.f857a2a4.jpg";